import { styled, keyframes } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssSpacing } from "../../util/styles.js";

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
`;

export const Wrapper = styled.div<{ $hasPlayed: boolean }>`
  position: relative;
  height: 180px;

  .video-poster {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  button {
    position: absolute;
    top: calc(50% - 35px);
    left: calc(50% - 35px);
    z-index: 1;
    width: 70px;
    height: 70px;
    background: none;
    border: none;
    cursor: pointer;
    animation: ${pulse} 5s infinite;
  }

  button svg path {
    fill: #fff;
  }

  video,
  iframe {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: ${(props) => (props.$hasPlayed ? "contain" : "cover")};
  }

  .video-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(255, 255, 255, 0.5);
    padding: ${cssSpacing("l", 0)};

    > p {
      text-align: center;
      max-width: 600px;
    }
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    height: 450px;
  }
`;
